import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { parsePageData } from "./parser"

const initialState = {
    widgets: [],
    dialogs: {},
    isError: false,
}

export const leadGenSlice = createSlice({
    name: "leadGen",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchLeadGenData.fulfilled, (state, action) => {
            state.isError = false
            state.widgets = action.payload.widgets || []
            state.dialogs = action.payload.dialogs || {}
        }),
            builder.addCase(fetchLeadGenData.rejected, (state) => {
                state.isError = true
            })
    },
})

export const fetchLeadGenData = createAsyncThunk(
    "leadGen/fetchLeadGenData",
    async (_arg, { rejectWithValue, extra: { api } }) => {
        try {
            const response = await api.get("/api/v1/obesity_management/survey", { params: _arg })

            if (response?.is_success) {
                const parsedData = parsePageData(response.data)
                return Promise.resolve(parsedData)
            }
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const submitLeadForm = createAsyncThunk(
    "leadGen/submitLeadForm",
    async (_arg, { rejectWithValue, extra: { api } }) => {
        const successCallback = _arg?.successCallback
        const errorCallback = _arg?.errorCallback

        try {
            const res = await api.post("/api/v1/obesity_management/generate_lead", _arg.payload)
            if (typeof successCallback === "function") successCallback(res?.is_success, res?.data?.message)
            return Promise.resolve(res?.is_success)
        } catch (error) {
            if (typeof errorCallback === "function") errorCallback(error)
            return rejectWithValue(error)
        }
    }
)

export const leadGenReducer = leadGenSlice.reducer
